export const ZEN_MODE_BODY_CLASS = 'FullScreenRoute--open';
